import React, { useState } from 'react';

import styled from 'styled-components';

import { connect, useDispatch } from 'react-redux';
import { translate } from 'react-translate';
import { withRouter } from 'react-router-dom';

import SelectOnTab from '@components/SelectOnTab/SelectOnTab';

import { SET_BUDGET_ORDER } from '@redux/budget/types';

export const BUDGET_ORDERS = {
  AZ: 'AZ',
  ZA: 'ZA',
  GV: 'GV',
  SV: 'SV',
  GTV: 'GTV',
  STV: 'STV',
  GRV: 'GRV',
  SRV: 'SRV',
};

const OptionStyled = styled('option')``;

const BudgetOrder = () => {
  const [order, setOrder] = useState('');

  const dispatch = useDispatch();

  const handleBudgetOrderSelect = (e) => {
    setOrder(e.target.value);
    dispatch({
      type: SET_BUDGET_ORDER.SUCCESS,
      budgetOrder: e.target.value,
    });
  };

  return (
    <div style={{ marginRight: '10px' }}>
      <SelectOnTab iconSelect={['fal', 'sort']} onChange={handleBudgetOrderSelect} value={order}>
        <OptionStyled key="order" value={null}>
          Ordenar
        </OptionStyled>
        <OptionStyled key={BUDGET_ORDERS.AZ} value={BUDGET_ORDERS.AZ}>
          A - Z
        </OptionStyled>
        <OptionStyled key={BUDGET_ORDERS.ZA} value={BUDGET_ORDERS.ZA}>
          Z - A
        </OptionStyled>
        <OptionStyled key={BUDGET_ORDERS.GV} value={BUDGET_ORDERS.GV}>
          Maior verba investida
        </OptionStyled>
        <OptionStyled key={BUDGET_ORDERS.SV} value={BUDGET_ORDERS.SV}>
          Menor verba investida
        </OptionStyled>
        <OptionStyled key={BUDGET_ORDERS.GTV} value={BUDGET_ORDERS.GTV}>
          Maior verba total
        </OptionStyled>
        <OptionStyled key={BUDGET_ORDERS.STV} value={BUDGET_ORDERS.STV}>
          Menor verba total
        </OptionStyled>
        <OptionStyled key={BUDGET_ORDERS.GRV} value={BUDGET_ORDERS.GRV}>
          Maior verba restante
        </OptionStyled>
        <OptionStyled key={BUDGET_ORDERS.SRV} value={BUDGET_ORDERS.SRV}>
          Menor verba restante
        </OptionStyled>
      </SelectOnTab>
    </div>
  );
};

const mapStateToProps = (state) => ({
  budgetReducer: state.budgetReducer,
  authenticationReducer: state.authenticationReducer,
});

export default withRouter(connect(mapStateToProps)(translate('NewOverall')(BudgetOrder)));
